module.exports = __webpack_public_path__ + "static/coo-38af7eb40bd9b30a2199c2ef59beab52.jpg";